export const enum SYNC_TO_WEB_VIEW_KEYS {
    toast = 'TOAST',
    routeChange = 'ROUTE_CHANGE',
    scroll = 'SCROLL',
    showSolvePreview = 'SHOW_SOLVE_PREVIEW',
    storeSyncClient = 'STORE_SYNC_CLIENT',
    storeSyncSettings = 'STORE_SYNC_SETTINGS',
    storeSyncPrompt = 'STORE_SYNC_PROMPT',
    storeSyncSource = 'STORE_SYNC_SOURCE',
}

export const syncToWebViewKeys: string[] = [
    'TOAST',
    'ROUTE_CHANGE',
    'SCROLL',
    'SHOW_SOLVE_PREVIEW',
    'STORE_SYNC_CLIENT',
    'STORE_SYNC_SETTINGS',
    'STORE_SYNC_PROMPT',
    'STORE_SYNC_SOURCE',
] as const;

export const enum SYNC_TO_DESKTOP_APP_KEYS {
    startSession = 'START_SESSION',
}

export const syncToDesktopAppKeys: string[] = ['START_SESSION'] as const;
